/* template */
<template><div class="mpx-root-view"><es-layout :leftArrow="(true)" navbarTitle="订单详情" :navbarStyle="(navbarStyle)" :esMainStyle="(esMainStyle)"><order-state-head iconName="exclamation-circle" title="改签失败" subTitle="改签失败，建议您更改坐席或车次信息后重新改签" :isSimplified="(true)"/><order-info-list @click="showSSI" :orderList="(orderList)" class="order-body"/></es-layout><drawer-bottom :show="(showStayInfo)" title="时刻表" @close="closeSSI" showDefaultNav><station-stay-info :stayInfo="(stayInfo)" :style='["height:100%;"] | transRpxStyle' v-if="(showStayInfo)"/></drawer-bottom></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m60df21f3"}'>
 .order-body
 	padding 12px 12px 120px 12px
 	min-height 50vh
 	border-radius 16px 16px 0 0
 	background-image linear-gradient(179deg, #FAFBFD 0%, #F0F1F4 6%, #F0F1F4 100%)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m60df21f3"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./occupy-failed.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./occupy-failed.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m60df21f3"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'order-state-head':getComponent(require("./components/order-detail-head-state-card.mpx?isComponent&outputPath=components%2Forder-detail-head-state-card1d2f5e66%2Findex")),'drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'order-info-list':getComponent(require("../../components/order-info-list/index.mpx?isComponent&outputPath=components%2Findex55870adc%2Findex")),'station-stay-info':getComponent(require("../../components/station-stay-info/index.mpx?isComponent&outputPath=components%2Findexe1125406%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
